const siderBar = {
  profile: "Profilo",
  history: "Storia",
  setting: "Impostazione",
  promotion: "Promozione",
};

export default siderBar;